import { PICKABLE_TYPES } from 'src/constants/Constants'

export const INITIAL_INVENTORY_COUNTS_SEARCH_PARAMS = {
  page: 1,
  id: '',
  client_id: '',
  inventory_count_status_id: '',
  sort_method: 'desc',
  order_by: 'id',
}

export const INITIAL_INVENTORY_COUNT_ITEMS_SEARCH_PARAMS = {
  page: 1,
  id: '',
  sku_upc_like: '',
  item_description: '',
  location_like: '',
  warehouse_name: '',
  user_id: '',
  pickable_type_id: '',
  lot: '',
  inventory_count_item_status_id: '',
  system_updated: '',
  limit: '50',
  group: 0,
}

export const INITIAL_INVENTORY_COUNT_CREATE_PARAMS = {
  client_id: '',
  warehouse_id: '',
  warehouse_ids: [],
  location_ids: [],
  item_ids: [],
  item_type_ids: [],
  item_categories: [],
  uom_type_id: '',
  note: '',
}

export const INITIAL_INVENTORY_COUNT_MOBILE_SEARCH_PARAMS = {
  location_name: '',
}

export const INVENTORY_COUNT_MOBILE_STEPS = {
  STEP_LOCATION: 'location',
  STEP_ITEMS: 'items',
  STEP_ITEM: 'item',
  STEP_EMPTY: '',
}

export const INITIAL_LOCATION_QUANTITY = {
  locations: 0,
  locations_assign: 0,
  pickable_type_id: PICKABLE_TYPES.HAND,
}

export const ACTION_TYPES = {
  COMPLETED: 'completed',
  LOCATIONS_ASSIGN: 'locations_assign',
}
